module.exports = __webpack_public_path__ + "img/sun-icon.e93494c1.svg";